export const colors = [
  // '#2580D3',
  // '#EE4044',
  // '#FBC335',
  // '#76B62A',
  // '#1F98AC',
  // '#F584AC',
  // '#F39E27',
  // '#157E5B',
  // '#3853C4',
  // '#AD45C7',
  // '#FB7E2B',
  // '#6DDA7F'
  '#002040',
  '#00B395',
  '#C3CAD1',
  '#00FFD5',
  '#D4FF00',
  '#F2FFB3',
]
export const pieColors = ['#2580D3', '#EE4044', '#FBC335', '#76B62A', '#1F98AC', '#F584AC', '#F39E27', '#157E5B', '#3853C4', '#AD45C7', '#FB7E2B', '#6DDA7F']
